 <template>
  <li @click="toggleComplete">
    <span
      class="check"
      :class="{
        complete: project.complete,
        'check-hover-dark': mode === 'dark' && !project.complete,
        'check-hover': mode === 'light' && !project.complete,
      }"
    >
      <img
        v-if="project.complete"
        src="../../assets/images/icon-check.svg"
        alt="check"
      />
    </span>

    <p
      v-if="project.complete"
      :class="mode === 'dark' ? 'text-complete-dark' : 'text-complete'"
    >
      <del> {{ project.title }} </del>
    </p>

    <p v-else :class="{ 'text-dark': mode === 'dark' }">
      {{ project.title }}
    </p>

    <svg-icon
      v-if="project.complete"
      @click.stop="delItem"
      class="trash"
      name="bin"
    ></svg-icon>
  </li>
</template>

 <script>
export default {
  emits: ["toggleComplete", "deleteItem"],
  data() {
    return {
      uri: `${process.env.VUE_APP_URI}${this.id}`,
    };
  },
  components: {},
  props: ["project", "id", "mode"],

  methods: {
    toggleComplete() {
      if (!this.uri.includes("undefined")) {
        fetch(this.uri, {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ complete: !this.project.complete }),
        })
          .then(() => this.$emit("toggleComplete", this.project.id))
          .catch((e) => console.log(e));
      }

      this.$emit("toggleComplete", this.project.id);
    },

    delItem() {
      if (!this.uri.includes("undefined")) {
        fetch(this.uri, {
          method: "DELETE",
        })
          .then(() => {
            this.$emit("deleteItem", this.id);
          })
          .catch((e) => console.log(e));
      }
      this.$emit("deleteItem", this.id);
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  border-bottom: 1px solid #e3e4f1;
  padding: 2rem 0;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.check {
  display: inline-block;
  width: 2.4rem;
  height: 2.4rem;
  margin: 0 2.4rem;
  border: 1px solid #e3e4f1;
  border-radius: 50%;
  overflow: hidden;
}

.check-hover {
  &:hover {
    &:hover {
      background-clip: padding-box, border-box;
      background-origin: padding-box, border-box;
      background-image: linear-gradient(135deg, #fff, #fff),
        linear-gradient(135deg, #5dd3fe, #c058f3);
      border: 1px transparent solid;
    }
  }
}

img {
}

.check-hover-dark {
  &:hover {
    background-clip: padding-box, border-box;
    background-origin: padding-box, border-box;
    background-image: linear-gradient(135deg, #25273d, #25273d),
      linear-gradient(135deg, #5dd3fe, #c058f3);
    border: 1px transparent solid;
  }
}

.trash {
  z-index: 99;
  transition: all 0.1s;
  fill: #9495a5;
  width: 1.8rem;
  height: 1.8rem;

  &:hover {
    transform: translateY(-2px) scale(1.1);
    fill: rgb(224, 125, 125);
  }
}

p {
  color: #494c6b;
  flex: 0.9;
}

img {
}

// complete
.complete {
  background-image: linear-gradient(to right bottom, #55ddff, #c058f3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.text-complete {
  color: #d1d2da;
}

.text-dark {
  color: #c8cbe7;
}

.text-complete-dark {
  color: #4d5067;
}
</style>
